module.exports = __webpack_public_path__ + "img/ar_logo.736f0819.png";